import { UIFormCompAggregationSettingsItem } from './aggregation-settings';
import { UIAggregationMethod, UIAggregationType } from './aggregation-method';

export class AggregationSettingsHelper {
    
    public static onAggregationMethodChange(formComp: UIFormCompAggregationSettingsItem, newValue: UIAggregationType): void {
        if (formComp.aggregationMethod.type === UIAggregationType.sum) {
            formComp.aggregationMethod.columnIndex = 'None';
        }
    }

    public static onColumnToAvgChange(aggrMethod: UIAggregationMethod, allFormComps: UIFormCompAggregationSettingsItem[]): void {
        if (Number.isInteger(aggrMethod.columnIndex)) {
            aggrMethod.type = UIAggregationType.averageSomehow;
            for (let i = 0; i < allFormComps.length; ++i) {
                if (allFormComps[i].aggregationMethod.type === UIAggregationType.averageSomehow
                        && !Number.isInteger(allFormComps[i].aggregationMethod.columnIndex)
                        && allFormComps[i].columnIx != aggrMethod.columnIndex) {
                    allFormComps[i].aggregationMethod.columnIndex = aggrMethod.columnIndex;
                }
            }
        }
    }
}
